<template>
    <div class="ur-filezone">
        <div class="ur-filezone__summary">
            <div class="ur-filezone__summary__info">
                {{ msgTotal }} <span class="filecount">{{ attachmentList.length }}</span>
                |
                ({{ totalFileSize | byteFormat }})
            </div>
        </div>

        <div class="ur-filezone__detail">
            <div class="ur-filezone__control">
                <div class="ur-filezone__control__info">
                    <ur-checkbox class="ur-filezone__file__checkbox" small :checked="selectAllChecked"
                                 :checked-icon="selectAllCheckedIcon" @input="toggleSelectAll"/>
                </div>
                <div class="ur-filezone__control__download-btn">
                    <ur-button small @click="download(selectedFile)" :disabled="selectedFile.length === 0">
                        {{ msgBtnDownload }}
                    </ur-button>
                </div>
                <div class="ur-filezone__control__collapse-btn">
                    <ur-icon v-if="displayFileList" @click="toggleDisplay()">collapse_menu</ur-icon>
                    <ur-icon v-else @click="toggleDisplay()">expand_menu</ur-icon>
                </div>
            </div>
            <div class="ur-filezone__file" v-show="displayFileList" v-for="(attach) in attachmentList"
                 :key="attach.fileId"
                 :class="{'ur-filezone__file__selected' : isSelected(`${contextHost}/${url}/${attach.fileId}`)}">
                <ur-checkbox class="ur-filezone__file__checkbox" small v-model="selectedFile"
                             :value="`${contextHost}/${url}/${attach.fileId}`"/>
                <a :href="`${contextHost}/${url}/${attach.fileId}`">
                    {{ attach.fileName }} ({{ attach.fileSize|byteFormat }})
                </a>
                <a class="ur-filezone__file__icon-link" :href="`${contextHost}/${url}/${attach.fileId}`"
                   :id="`article-detail-page-file-download-${attach.fileId}`">
                    <ur-icon icon="download"/>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {byteFilter} from '../../../filters/numberFilter/urByteFilter';

export default {
    name: 'ur-filezone',
    props: {
        contextHost: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: 'rest/v2/file/download'
        },
        attachmentList: {
            type: Array,
            default: () => {
            }
        },
        msgBtnDownload: {
            type: String,
            default: 'Download'
        },
        msgTotal: {
            type: String,
            default: 'Total'
        }
    },
    filters: {
        byteFormat(value) {
            return byteFilter(value);
        }
    },
    data() {
        return {
            displayFileList: true,
            selectedFile: [],
            selectAll: false,
        }
    },
    computed: {
        totalFileSize() {
            let totalFileSize = 0;
            for (let attachment of this.attachmentList) {
                totalFileSize += attachment.fileSize;
            }
            return totalFileSize;
        },
        selectAllChecked() {
            return (this.selectedFile.length > 0);
        },
        selectAllCheckedIcon() {
            return (this.selectedFile.length === this.attachmentList.length) ? 'checked' : 'indeterminate';
        }
    },
    methods: {
        isSelected(path) {
            return -1 < this.selectedFile.indexOf(path);
        },
        toggleDisplay() {
            this.displayFileList = !this.displayFileList;
        },
        download(files) {
            for (let i in files) {
                const link = document.createElement('a');
                (parseInt(i) === files.length - 1)
                    ? link.setAttribute('target', '_self')
                    : link.setAttribute('target', '_blank');
                link.href = files[i];
                document.body.appendChild(link);
                link.click();
            }
        },
        toggleSelectAll() {
            let fileCount = this.attachmentList.length;
            if (this.selectedFile.length === fileCount) {
                for (let idx = 0; idx < fileCount; idx++) {
                    this.selectedFile.pop();
                }
            } else {
                this.attachmentList.forEach(attach => {
                    let attachPath = `${this.contextHost}/${this.url}/${attach.fileId}`;
                    if (this.selectedFile.indexOf(attachPath) < 0) {
                        this.selectedFile.push(attachPath);
                    }
                });
            }
        }
    }
};
</script>